
import React from "react";
import { UserPlus, Group, BriefcaseBusiness } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TeamConfiguration } from "./TeamConfiguration";
import { SelectedTeamMembers } from "./SelectedTeamMembers";
import { FreelancerSearch } from "./FreelancerSearch";
import { SavedTeams } from "./SavedTeams";
import { TeamTemplates } from "./TeamTemplates";

interface TeamBuilderTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  teamName: string;
  setTeamName: (name: string) => void;
  selectedSkills: string[];
  setSelectedSkills: (skills: string[]) => void;
  projectType: string;
  setProjectType: (type: string) => void;
  teamSize: string;
  setTeamSize: (size: string) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedFreelancers: any[];
  availableFreelancers: any[];
  addToTeam: (freelancer: any) => void;
  removeFromTeam: (id: string | number) => void;
  saveTeam: () => void;
}

export const TeamBuilderTabs: React.FC<TeamBuilderTabsProps> = ({
  activeTab,
  setActiveTab,
  teamName,
  setTeamName,
  selectedSkills,
  setSelectedSkills,
  projectType,
  setProjectType,
  teamSize,
  setTeamSize,
  searchQuery,
  setSearchQuery,
  selectedFreelancers,
  availableFreelancers,
  addToTeam,
  removeFromTeam,
  saveTeam
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full mb-8">
      <TabsList className="grid grid-cols-3 w-full max-w-md">
        <TabsTrigger value="build" className="flex items-center gap-2">
          <UserPlus className="h-4 w-4" />
          <span>Build Team</span>
        </TabsTrigger>
        <TabsTrigger value="saved" className="flex items-center gap-2">
          <Group className="h-4 w-4" />
          <span>Saved Teams</span>
        </TabsTrigger>
        <TabsTrigger value="templates" className="flex items-center gap-2">
          <BriefcaseBusiness className="h-4 w-4" />
          <span>Templates</span>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="build" className="mt-6 space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Team Configuration Panel */}
          <TeamConfiguration 
            teamName={teamName}
            setTeamName={setTeamName}
            selectedSkills={selectedSkills}
            setSelectedSkills={setSelectedSkills}
            projectType={projectType}
            setProjectType={setProjectType}
            teamSize={teamSize}
            setTeamSize={setTeamSize}
            selectedFreelancers={selectedFreelancers}
            saveTeam={saveTeam}
          />

          <div className="lg:col-span-2 space-y-6">
            {/* Selected Team Members */}
            <SelectedTeamMembers 
              selectedFreelancers={selectedFreelancers}
              removeFromTeam={removeFromTeam}
            />

            {/* Freelancer Search */}
            <FreelancerSearch 
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              availableFreelancers={availableFreelancers}
              addToTeam={addToTeam}
            />
          </div>
        </div>
      </TabsContent>

      <TabsContent value="saved" className="mt-6">
        <SavedTeams setActiveTab={setActiveTab} />
      </TabsContent>

      <TabsContent value="templates" className="mt-6">
        <TeamTemplates setActiveTab={setActiveTab} />
      </TabsContent>
    </Tabs>
  );
};
